import EnquiryTypesConfigContainer from './EnquiryTypesConfigContainer';
export default EnquiryTypesConfigContainer;
